import { useAuthContext } from 'context/AuthContext';
import { useStorefrontContext } from 'context/StorefrontContext';

/** true si el visitante puede ver precios (logueado, o anónimo con la opción desactivada). */
export const useCanSeePrices = (): boolean => {
  const { isAuthenticated } = useAuthContext();
  const { features } = useStorefrontContext();
  if (isAuthenticated) return true;
  return !features.hidePricesForAnonymous;
};
